var countryJson = require('../../../node_modules/country-code-info/data/countries.json')

module.exports.findCountry =  function findCountry(fifacode) {
  for (var i = 0; i < countryJson.length; i++) {
    if (fifacode == 'ENG') {
      return 'gb'
    }
    if (fifacode == 'SCO') {
      return 'gb'
    }
    if (countryJson[i].fifa == fifacode) {
      return countryJson[i].a2.toLowerCase();
    }
  }
}

module.exports.findCountryUpper = function findCountryUpper(fifacode) {
  for (var i = 0; i < countryJson.length; i++) {
    if (fifacode == 'ENG') {
      return 'gb'
    }
    if (fifacode == 'SCO') {
      return 'gb'
    }
    if (countryJson[i].fifa == fifacode) {
      return countryJson[i].a2;
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/helpers/countries.js